<template>
	<div class="basic_wrap">
		<!-- 返回按钮 -->
		<div class="back-btn" @click="$router.go(-1)">
			<img src="../images/draw/back.png" />
		</div>

		<!-- 转盘区域 -->
		<div class="zp-bg1">
			<div class="overall">
				<div class="zp-top">
					<div class="zp-box">
						<!-- 转盘 -->
						<div class="panzi" ref="panzi">
							<!-- 色块背景 -->
							<div class="bck-box">
								<div
									class="bck"
									v-for="(item, index) in list"
									:key="index"
									:style="`transform: rotate(${index * (360 / list.length)}deg) skewY(-${90 - 360 / list.length}deg);`"
								></div>
							</div>
							<!-- 奖品文字 -->
							<div
								class="jiang"
								v-for="(item, index) in list"
								:key="index"
								:style="`transform: rotate(${index * (360 / list.length) + 360 / (2 * list.length)}deg) translateY(-85px);`"
							>
								<span class="title">{{ item.title }}</span>
							</div>
						</div>
						<!-- 指针和抽奖按钮 -->
						<div class="start-btn" :class="{ loading }" @click="draw()">GO</div>
					</div>
				</div>
			</div>
			<!-- 当前剩余抽奖次数 -->
			<div class="zp-num">
				<span>我的抽奖次数：</span>
				<span>{{ chances }}</span>
			</div>
		</div>

		<!-- 历史中奖记录 -->
		<div class="zp-bg2">
			<div class="my-record">
				<p>我的历史中奖记录</p>
			</div>
			<div class="record-list">
				<van-empty v-if="records.length === 0" description="暂无中奖记录" />
				<div v-else>
					<div v-for="(record, index) in records" :key="index">
						<p>{{ record.create_time }} - {{ record.title }} - {{ record.description }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from "../../utils/fetch";
import Vue from "vue";
import { Empty, Toast } from "vant";

Vue.use(Empty);
Vue.use(Toast);

export default {
	data() {
		return {
			chances: 0,                // 当前用户剩余的抽奖次数
			list: [],                  // 转盘上的奖品列表
			records: [],               // 用户历史中奖记录
			loading: false,            // 防止重复点击抽奖按钮
		};
	},
	created() {
		// 页面加载时获取奖品和历史抽奖记录
		this.fetchPrizes();
	},
	methods: {
		/**
		 * 获取奖品列表以及用户抽奖次数和历史记录
		 */
		async fetchPrizes() {
			try {
				// 调用后端接口获取奖品和历史记录
				const response = await Fetch("/user/getPrizes");

				if (response.code === 1) {
					// 更新奖品列表
					this.list = response.data.list.map(item => ({
						id: item.id,
						title: item.title,          // 奖品名称
						description: item.description, // 奖品描述
						type: item.type             // 奖品类型
					}));

					// 更新用户剩余抽奖次数
					this.chances = response.data.remaining_chances || 0;

					// 更新用户历史中奖记录
					this.records = response.data.records || [];
				} else {
					// 处理接口返回的错误信息
					Toast.fail(response.msg || "获取奖品信息失败");
				}
			} catch (error) {
				// 捕获接口调用异常
				console.error("获取奖品接口异常：", error);
				Toast.fail("网络错误，请稍后再试");
			}
		},

		/**
		 * 用户点击抽奖按钮进入抽奖流程
		 */
		async draw() {
			// 防止重复提交或抽奖次数不足
			if (this.loading) return;
			if (this.chances <= 0) {
				Toast.fail("您的抽奖次数已用完");
				return;
			}

			this.loading = true; // 启动加载状态，防止重复点击
			try {
				// 调用抽奖接口
				const response = await Fetch("/user/draw");

				if (response.code === 1) {
					// 抽奖成功后，获取中奖奖品
					const prize = response.data.prize;

					// 找到中奖奖品在转盘中的索引
					const winnerIndex = this.list.findIndex(item => item.title === prize.title);

					if (winnerIndex !== -1) {
						// 开启转盘动画，并更新 UI 显示的中奖信息
						this.startSpinAnimation(winnerIndex, response);
					} else {
						// 如果索引找不到，说明数据有问题
						console.error("奖品匹配失败！转盘奖品和后端数据不一致。");
						Toast.fail("奖品匹配异常，请稍后再试");
						this.loading = false;
					}
				} else {
					// 处理抽奖失败的情况
					Toast.fail(response.msg || "抽奖失败，请稍后再试");
					this.loading = false;
				}
			} catch (error) {
				// 捕获接口异常
				console.error("抽奖接口异常：", error);
				Toast.fail("网络错误，请稍后再试");
				this.loading = false;
			}
		},

		/**
		 * 转盘动画实现并同步更新中奖信息
		 * @param {number} winnerIndex - 转盘上中奖奖品的索引
		 * @param {object} response - 抽奖接口返回的内容
		 */
		startSpinAnimation(winnerIndex, response) {
			const panzi = this.$refs.panzi;     // 获取转盘 DOM 节点
			const sliceAngle = 360 / this.list.length; // 每个奖品所占的角度
			const randomSpins = Math.floor(Math.random() * 5) + 5; // 随机转盘圈数（5-10）

			// 动态计算指针指向色块的中心位置
			const finalAngle = randomSpins * 360 + (winnerIndex * sliceAngle) + (sliceAngle / 2);

			// 清除之前的动画样式并重置转盘位置
			panzi.style.transition = "none";
			panzi.style.transform = "rotate(0deg)";

			// 启动转盘旋转动画
			setTimeout(() => {
				panzi.style.transition = "transform 3s ease";
				panzi.style.transform = `rotate(-${finalAngle}deg)`;
			}, 50);

			// 动画完成后显示中奖结果
			setTimeout(() => {
				// 提示中奖信息
				Toast.success(`恭喜您中奖了：${this.list[winnerIndex].title}`);

				// 更新剩余抽奖次数和中奖记录
				this.chances = response.data.remaining_chances || 0;
				this.records = response.data.records || [];

				// 重置加载状态
				this.loading = false;
			}, 3000); // 动画时间为 3 秒
		}
	}
};
</script>

<style lang="scss" scoped>
	$zp_size: 255px; //转盘尺寸
		$btn_size: 60px; //抽奖按钮尺寸
		$time: 3s; //转动多少秒后停下的时间
	
		.back-btn {
			position: fixed;
			top: 10px;
			left: 10px;
			img{
				width: 20px;
			}
		}
	.zp-bg1 {
		background: url(../images/draw/bg1.png) no-repeat center center;
		background-size: 100% 100%;
		width: 100%;
		height: 330px;
	}

	.zp-bg2 {
		background: url(../images/draw/bg2.png) no-repeat center center;
		background-size: 100% 100%;
		width: 100%;
		margin-top: -45px;
		position: absolute;

		.my-record {
			margin-top: 175px;
			position: relative;
			background: url(../images/draw/record.png) no-repeat center center;
			background-size: 100% 100%;
			text-align: center;

			p {
				padding:  24px 0 28px 0;
				font-size: 16px;
				font-weight: bold;
				color: #FF0000;
			}
		}
		.record-list{
			background: url(../images/draw/record_bg.png) no-repeat center center;
			background-size: 100% 100%;
			text-align: center;
			width: 90%;
			margin-left: 5%;
			padding: 15px 0;
			p {
				width: 90%;
				margin-left: 5%;
				padding:  10px;
				font-size: 14px;
				font-weight: bold;
				color: #FF0000;
				border-bottom: 1px solid #9ab6c340;
			}
		}
	}
	.zp-num{
		position: relative;
		top: 55px;
		z-index: 22;
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		color: #FFFFFF;
		span:nth-child(1) {
		}
		
		span:nth-child(2) {
			font-size: 20px;
			font-weight: bold;
			color: #bdff1e;
		}
	}

	.overall {
		z-index: 11;
		position: relative;
		top: 65px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.zp-top {
		background: url(../images/draw/draw.png) no-repeat center center;
		background-size: 100% 100%;
		width: 300px;
		height: 360px;
	}

	.zp-box {
		user-select: none;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		width: $zp_size;
		height: $zp_size;
		left: 23px;
		top: 32px;

		/* 抽奖按钮 */
		.start-btn {
			display: inline-block;
			background: #f53737;
			position: relative;
			z-index: 2;
			cursor: pointer;
			width: $btn_size;
			height: $btn_size;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			color: white;
			font-size: 16px;
			font-weight: bold;
			box-sizing: border-box;
			position: relative;
			z-index: 2;

			&::before {
				content: '';
				width: 0;
				height: 0;
				border: 26px solid transparent;
				border-top: 44px solid transparent;
				border-bottom: 40px solid #f53737;
				position: absolute;
				top: -69px;
				z-index: -1;
			}
		}

		/* 盘子样式 */
		.panzi {
			overflow: hidden;
			border-radius: 50%;
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;

			/* 每个奖项的样式 */
			.jiang {
				position: absolute;

				.title {
					font-weight: bold;
					font-size: 14px;
					color: #3b3b3b;
				}
			}
		}

		.bck-box {
			overflow: hidden;
			position: absolute;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0;
			border-radius: 50%;

			/* 转盘扇形背景 */
			.bck {
				box-sizing: border-box;
				position: absolute;
				width: 100%;
				height: 100%;
				opacity: 1;
				top: -50%;
				left: 50%;
				transform-origin: 0% 100%;
			}

			/* 转盘背景色 */
			.bck:nth-child(2n) {
				background: #ffd452;
			}

			.bck:nth-child(2n + 1) {
				background: #feb54c;
			}
		}

		.wr0,
		.wr1,
		.wr2,
		.wr3,
		.wr4,
		.wr5 {
			animation-duration: $time;
			animation-timing-function: ease;
			animation-fill-mode: both;
			animation-iteration-count: 1;
		}

		.wr0 {
			animation-name: play0;
		}

		.wr1 {
			animation-name: play1;
		}

		.wr2 {
			animation-name: play2;
		}

		.wr3 {
			animation-name: play3;
		}

		.wr4 {
			animation-name: play4;
		}

		.wr5 {
			animation-name: play5;
		}

		@keyframes play0 {
			to {
				transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 0));
			}
		}

		@keyframes play1 {
			to {
				transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 1));
			}
		}

		@keyframes play2 {
			to {
				transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 2));
			}
		}

		@keyframes play3 {
			to {
				transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 3));
			}
		}

		@keyframes play4 {
			to {
				transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 4));
			}
		}

		@keyframes play5 {
			to {
				transform: rotate(calc(5 * 360deg + 360deg / var(--nums) * 5));
			}
		}
	}
</style>
